// Browser detection Minified
!function(){var i=!!window.opr&&!!opr.addons||!!window.opera||navigator.userAgent.indexOf(" OPR/")>=0,e="undefined"!=typeof InstallTrigger,o=!!navigator.userAgent.match(/iPad/i)||!!navigator.userAgent.match(/iPhone/i)&&!!navigator.userAgent.match(/WebKit/i)&&!navigator.userAgent.match(/CriOS/i)||/constructor/i.test(window.HTMLElement)||"[object SafariRemoteNotification]"===(!window.safari||"undefined"!=typeof safari&&safari.pushNotification).toString(),n=!!document.documentMode,t=!n&&!!window.StyleMedia,a=!!window.chrome&&!!window.chrome.webstore,r=(a||i)&&!!window.CSS,s=[];i&&s.push("is-opera"),e&&s.push("is-firefox"),o&&s.push("is-safari"),n&&s.push("is-ie"),t&&s.push("is-edge"),a&&s.push("is-chrome"),r&&s.push("is-blink"),document.documentElement.className+=" "+s.join(" ")}();

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

})();